<template>
  <b-modal size="lg" id="booking-modal" title="Enter Booking Details" title-class="font-18">
    <b-alert v-if="update" show variant="warning">
      Note: Price, Additional price & Discount are not auto calculated on booking update.
    </b-alert>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <b-form id="booking-form" @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider vid="reservations.lodging" rules="required" v-slot="{ errors }">
          <b-form-group label="Lodging" label-for="lodging">
            <Multiselect
              id="lodging"
              v-model="lodging"
              :options="lodgingsName"
              track-by="value"
              label="text"
              :allow-empty="false"
              deselect-label="Selected"
              @input="onLodgingChange"
            ></Multiselect>

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </ValidationProvider>

        <b-row>
          <b-col sm="6">
            <b-form-group label="Arrival" label-for="checkin">
              <ValidationProvider vid="reservations.checkin" rules="required" v-slot="{ errors }">
                <DatePicker
                  v-model="checkin_date"
                  class="w-100"
                  id="checkin"
                  placeholder="Checkin Date"
                  format="DD-MM-YYYY"
                  :disabled-date="disabledAfterCheckout"
                  @input="onDateRangeChange"
                ></DatePicker>

                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group label="Departure" label-for="checkout">
              <ValidationProvider vid="reservations.checkout" rules="required" v-slot="{ errors }">
                <DatePicker
                  v-model="checkout_date"
                  class="w-100"
                  id="checkout"
                  placeholder="Checkout Date"
                  format="DD-MM-YYYY"
                  :disabled-date="disabledBeforeCheckin"
                  @input="onDateRangeChange"
                ></DatePicker>

                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <b-form-group label="Adults" label-for="adults">
              <ValidationProvider rules="required|minimum:0" v-slot="{ errors }">
                <b-form-input
                  v-model="reservation.adults"
                  type="number"
                  id="adults"
                  placeholder="No of adults"
                  @change="onGuestsChange"
                ></b-form-input>

                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group label="Children" label-for="children">
              <ValidationProvider rules="required|minimum:0" v-slot="{ errors }">
                <b-form-input
                  v-model="reservation.children"
                  type="number"
                  id="children"
                  placeholder="No of children"
                  @change="onGuestsChange"
                ></b-form-input>

                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>
          </b-col>
        </b-row>

        <h5 class="my-4">
          <a
            @click="customerToggled = !customerToggled"
            v-b-toggle.customers
            class="text-dark"
            href="javascript:void(0);"
          >
            <i v-if="!customerToggled" class="bx bx-chevron-down"></i>
            <i v-else class="bx bx-chevron-up"></i>
            Customer Details
          </a>
        </h5>

        <b-collapse id="customers" class="mb-5" role="tabpanel">
          <b-form-group label="Customer" label-for="customer">
            <Multiselect
              id="customer"
              v-model="customer_id"
              :options="customersName"
              track-by="value"
              label="text"
              deselect-label="Unselect"
              @input="populateCustomer"
            ></Multiselect>
          </b-form-group>

          <b-row>
            <b-col sm="6">
              <b-form-group label="First name" label-for="first_name">
                <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                  <b-form-input
                    id="first_name"
                    v-model="customer.first_name"
                    placeholder="Enter first name"
                    :disabled="customerSelected"
                  ></b-form-input>

                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group label="Last Name" label-for="last_name">
                <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                  <b-form-input
                    id="last_name"
                    v-model="customer.last_name"
                    placeholder="Enter last Name"
                    :disabled="customerSelected"
                  ></b-form-input>

                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group label="Email" label-for="email">
            <ValidationProvider vid="customer.email" rules="email|required" v-slot="{ errors }">
              <b-form-input
                id="email"
                v-model="customer.email"
                type="email"
                placeholder="Enter email"
                :disabled="customerSelected"
              ></b-form-input>

              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>

          <b-form-group label="Phone number" label-for="phone_number">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <b-form-input
                id="phone_number"
                v-model="customer.phone_number"
                placeholder="Enter phone #"
                :disabled="customerSelected"
              ></b-form-input>

              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>
        </b-collapse>

        <h5 class="my-4" v-if="!update">
          <a @click="addOnToggled = !addOnToggled" v-b-toggle.addOns class="text-dark" href="javascript:void(0);">
            <i v-if="!addOnToggled" class="bx bx-chevron-down"></i>
            <i v-else class="bx bx-chevron-up"></i>
            Discounts & Add Ons
          </a>
        </h5>

        <b-collapse id="addOns" class="mb-5" role="tabpanel" v-if="!update">
          <b-form-group label="Add ons" label-for="additional_costs">
            <Multiselect
              id="additional_costs"
              v-model="reserved_add_ons"
              :options="additionalCostsName"
              track-by="value"
              label="text"
              :multiple="true"
              :allow-empty="true"
              deselect-label="Unselect"
              @input="calculateAdditionalCost"
            ></Multiselect>
          </b-form-group>

          <b-form-group label="Discounts" label-for="discounts">
            <Multiselect
              id="discounts"
              v-model="discount"
              :options="discountsName"
              track-by="value"
              label="text"
              :allow-empty="true"
              deselect-label="Unselect"
              @input="calculateDiscount"
            ></Multiselect>
          </b-form-group>
        </b-collapse>

        <h5 class="my-4">
          <a @click="priceToggled = !priceToggled" v-b-toggle.prices class="text-dark" href="javascript:void(0);">
            <i v-if="!priceToggled" class="bx bx-chevron-down"></i>
            <i v-else class="bx bx-chevron-up"></i>
            Prices
          </a>
        </h5>

        <b-collapse id="prices" class="mb-5" role="tabpanel">
          <b-form-group class="ml-0" label-cols="6" label="Price" label-for="price">
            <ValidationProvider rules="required|greater:@discount_value" v-slot="{ errors }">
              <b-form-input id="price" v-model="reservation.price" type="number" step=".01"></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>

          <b-form-group class="ml-0" label-cols="6" label="Additional Price" label-for="additional_price">
            <b-form-input
              id="additional_price"
              v-model="reservation.additional_price"
              type="number"
              step=".01"
            ></b-form-input>
          </b-form-group>

          <ValidationProvider vid="discount_value">
            <b-form-group class="ml-0" label-cols="6" label="Discount" label-for="discount_value">
              <b-form-input
                id="discount_value"
                step=".01"
                v-model="reservation.discount_value"
                type="number"
              ></b-form-input>
            </b-form-group>
          </ValidationProvider>
        </b-collapse>

        <h5 class="my-4">
          <a @click="detailsToggled = !detailsToggled" v-b-toggle.details class="text-dark" href="javascript:void(0);">
            <i v-if="!detailsToggled" class="bx bx-chevron-down"></i>
            <i v-else class="bx bx-chevron-up"></i>
            Details
          </a>
        </h5>

        <b-collapse id="details" role="tabpanel">
          <b-form-group class="ml-0" label="Notes" label-for="notes">
            <textarea
              id="notes"
              v-model="booking.notes"
              class="form-control"
              rows="5"
              placeholder="Enter notes"
            ></textarea>
          </b-form-group>
        </b-collapse>
      </b-form>
    </ValidationObserver>

    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="$bvModal.hide('booking-modal')">Close</b-button>
      <b-button form="booking-form" type="submit" variant="primary">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
import moment from "moment";
import { getLodgings, getCustomers, getPrices, getAdditionalCosts, getDiscounts, getRules } from "@/store/api";
import { createBooking, updateBooking } from "@/store/api";

export default {
  props: ["arrival", "departure", "reservations"],

  watch: {
    arrival() {
      this.checkin_date = this.arrival;
    },

    departure() {
      this.checkout_date = this.departure;
    },

    reservations() {
      this.bookings = this.reservations;
    },
  },

  data() {
    return {
      reserved_add_ons: [],
      discount: "",
      reservation: {
        id: "",
        lodging_id: "",
        checkin: "",
        checkout: "",
        adults: "",
        children: "",
        price: "",
        additional_price: "",
        discount_value: "",
        discount_id: "",
        reserved_add_ons_attributes: [],
      },
      customer: {
        id: "",
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
      },
      booking: {
        notes: "",
        employee_id: "",
        customer_id: "",
        customer_attributes: "",
        reservations_attributes: [],
      },
      bookings: this.reservations,
      lodging: "",
      checkin_date: this.arrival,
      checkout_date: this.departure,
      customer_id: "",
      lodgings: [],
      customers: [],
      prices: [],
      additionalCosts: [],
      discounts: [],
      rules: [],
      requiredCost: "",
      update: false,
      bookingId: "",
      customerSelected: false,
      customerToggled: false,
      priceToggled: false,
      detailsToggled: false,
      addOnToggled: false,
    };
  },

  created() {
    getLodgings({ active: true }).then((response) => (this.lodgings = response));
    getCustomers().then((response) => (this.customers = response));
    this.$root.$on("clearBooking", () => this.clearBooking());
    this.$root.$on("toggleEdit", (args) => this.toggleEdit(args));
  },

  computed: {
    lodgingsName() {
      return this.lodgings.map((lodging) => {
        return { value: lodging.id, text: lodging.attributes.name, base_price: lodging.attributes.base_price };
      });
    },

    customersName() {
      return this.customers.map((customer) => {
        return { value: customer.id, text: `${customer.attributes.email}` };
      });
    },

    additionalCostsName() {
      return this.additionalCosts
        .filter((additionalCost) => {
          return !additionalCost.attributes.required;
        })
        .map((additionalCost) => {
          return {
            value: additionalCost.id,
            text: additionalCost.attributes.title,
            price: additionalCost.attributes.price,
            fixed_price: additionalCost.attributes.fixed_price,
          };
        });
    },

    discountsName() {
      return this.discounts.map((discount) => {
        return {
          value: discount.id,
          text: discount.attributes.title,
          discount_value: discount.attributes.value,
          percentage: discount.attributes.percentage,
        };
      });
    },
  },

  methods: {
    clearBooking() {
      this.update = false;
      this.customerToggled = false;
      this.addOnToggled = false;
      this.priceToggled = false;
      this.detailsToggled = false;
      this.reserved_add_ons = [];
      this.lodging = "";
      this.discount = "";
      this.checkin_date = "";
      this.checkout_date = "";
      this.customer_id = "";
      this.customerSelected = false;
      this.booking.notes = "";
      this.booking.employee_id = "";
      this.booking.customer_id = "";
      this.booking.customer_attributes = "";
      this.booking.reservations_attributes = [];
      this.reservation.id = "";
      this.reservation.lodging_id = "";
      this.reservation.checkin = "";
      this.reservation.checkout = "";
      this.reservation.adults = "";
      this.reservation.children = "";
      this.reservation.price = "";
      this.reservation.additional_price = "";
      this.reservation.discount_value = "";
      this.reservation.reserved_add_ons_attributes = [];
      this.customer.id = "";
      this.customer.first_name = "";
      this.customer.last_name = "";
      this.customer.email = "";
      this.customer.phone_number = "";
    },

    disabledBeforeCheckin(date) {
      return date <= this.checkin_date;
    },

    disabledAfterCheckout(date) {
      if (!this.checkout_date) return false;
      return date >= this.checkout_date;
    },

    populateCustomer() {
      if (this.customer_id) {
        this.customerSelected = true;
        let selectedCustomer = this.customers.find((customer) => customer.id === this.customer_id.value);
        this.customer.first_name = selectedCustomer.attributes.first_name;
        this.customer.last_name = selectedCustomer.attributes.last_name;
        this.customer.email = selectedCustomer.attributes.email;
        this.customer.phone_number = selectedCustomer.attributes.phone_number;
      } else {
        this.customerSelected = false;
        this.customer.first_name = "";
        this.customer.last_name = "";
        this.customer.email = "";
        this.customer.phone_number = "";
      }
    },

    fetchPrices() {
      this.reservation.additional_price = 0;
      getPrices(
        this.lodging.value,
        moment(this.checkin_date).format("YYYY-MM-DD"),
        moment(this.checkout_date).subtract(1, "days").format("YYYY-MM-DD")
      ).then((response) => {
        this.prices = response;
        this.calculatePrice();
      });
      getAdditionalCosts({ lodging: this.lodging.value }).then((response) => {
        this.additionalCosts = response;
        this.calculateRequiredCost();
        this.calculateAdditionalCost();
      });
    },

    calculatePrice() {
      this.reservation.price = 0;
      for (let price of this.prices) {
        this.reservation.price += parseFloat(price.attributes.amount);
      }
      let remainingDays = moment(this.checkout_date).diff(this.checkin_date, "days") - this.prices.length;
      this.reservation.price += this.lodging.base_price * remainingDays;
    },

    calculateRequiredCost() {
      this.requiredCost = 0;
      let cost = 0;
      this.reservation.reserved_add_ons_attributes = [];
      for (let additionalCost of this.additionalCosts) {
        if (additionalCost.attributes.required) {
          if (additionalCost.attributes.fixed_price) {
            cost += parseFloat(additionalCost.attributes.price);
          } else {
            cost =
              parseFloat(additionalCost.attributes.price) * moment(this.checkout_date).diff(this.checkin_date, "days");
          }
          this.requiredCost += cost;
          this.reservation.reserved_add_ons_attributes.push({
            title: additionalCost.attributes.title,
            additional_cost_id: additionalCost.id,
            price: cost,
          });
        }
      }
    },

    calculateAdditionalCost() {
      this.reservation.additional_price = this.requiredCost;
      for (let i = 0; i < this.reserved_add_ons.length; i++) {
        if (this.reserved_add_ons[i].fixed_price) {
          this.reservation.additional_price += parseFloat(this.reserved_add_ons[i].price);
        } else {
          this.reservation.additional_price +=
            parseFloat(this.reserved_add_ons[i].price) * moment(this.checkout_date).diff(this.checkin_date, "days");
        }
      }
    },

    calculateDiscount() {
      if (this.discount != null) {
        if (this.discount.percentage) {
          this.reservation.discount_value = this.reservation.price * this.discount.discount_value * 0.01;
        } else {
          this.reservation.discount_value = this.discount.discount_value;
        }
      } else {
        this.reservation.discount_value = 0;
      }
    },

    calculateExtraGuestCost() {
      let extraGuests = 0;
      let extraCost = 0;
      for (let rule of this.rules) {
        if (this.reservation.adults && this.reservation.children) {
          extraGuests =
            parseInt(this.reservation.adults) +
            parseInt(this.reservation.children) -
            rule.attributes.charge_after_guests;
        } else if (this.reservation.adults) {
          extraGuests = parseInt(this.reservation.adults) - rule.attributes.charge_after_guests;
        } else if (this.reservation.children) {
          extraGuests = parseInt(this.reservation.children) - rule.attributes.charge_after_guests;
        }

        if (this.reservation.price && extraGuests > 0) {
          let totalDays = moment(this.checkout_date).diff(this.checkin_date, "days");
          let weight;
          if (
            moment(rule.attributes.start_date).isSameOrBefore(this.checkin_date) &&
            moment(rule.attributes.end_date).isSameOrAfter(this.checkout_date)
          ) {
            weight = moment(this.checkout_date).diff(this.checkin_date, "days") / totalDays;
          } else if (
            moment(rule.attributes.start_date).isSameOrBefore(this.checkin_date) &&
            moment(rule.attributes.end_date).isSameOrBefore(this.checkout_date)
          ) {
            weight = (moment(rule.attributes.end_date).diff(this.checkin_date, "days") + 1) / totalDays;
          } else if (
            moment(rule.attributes.start_date).isSameOrAfter(this.checkin_date) &&
            moment(rule.attributes.end_date).isSameOrBefore(this.checkout_date)
          ) {
            weight = (moment(rule.attributes.end_date).diff(rule.attributes.start_date, "days") + 1) / totalDays;
          } else if (
            moment(rule.attributes.start_date).isSameOrAfter(this.checkin_date) &&
            moment(rule.attributes.end_date).isSameOrAfter(this.checkout_date)
          ) {
            weight = moment(this.checkout_date).diff(rule.attributes.start_date, "days") / totalDays;
          }
          if (rule.attributes.percentage) {
            extraCost +=
              rule.attributes.extra_guest_cost * extraGuests * 0.01 * parseFloat(this.reservation.price) * weight;
          } else {
            extraCost += rule.attributes.extra_guest_cost * extraGuests * weight;
          }
        }
      }
      this.reservation.price = parseFloat(this.reservation.price) + extraCost;
    },

    onGuestsChange() {
      if (this.rules.length) {
        this.calculatePrice();
        this.calculateExtraGuestCost();
        this.calculateDiscount();
      }
    },

    onLodgingChange() {
      if (this.checkin_date && this.checkout_date && !this.update) {
        this.reserved_add_ons = [];
        this.discount = [];
        this.reservation.discount_value = 0;
        this.fetchPrices();
        this.calculateAdditionalCost();
        getDiscounts({ lodging: this.lodging.value }).then((response) => (this.discounts = response));
        getRules({
          lodging: this.lodging.value,
          start_date: moment(this.checkin_date).format("YYYY-MM-DD"),
          end_date: moment(this.checkout_date).subtract(1, "days").format("YYYY-MM-DD"),
        }).then((response) => {
          this.rules = response;
          this.onGuestsChange();
        });
      }
    },

    onDateRangeChange() {
      if (this.checkin_date && this.checkout_date && this.lodging && !this.update) {
        this.fetchPrices();
        getDiscounts({ lodging: this.lodging.value }).then((response) => (this.discounts = response));
        this.calculateRequiredCost();
        this.calculateAdditionalCost();
        this.calculateDiscount();
        getRules({
          lodging: this.lodging.value,
          start_date: moment(this.checkin_date).format("YYYY-MM-DD"),
          end_date: moment(this.checkout_date).subtract(1, "days").format("YYYY-MM-DD"),
        }).then((response) => {
          this.rules = response;
          this.onGuestsChange();
        });
      }
    },

    setBookings(booking) {
      this.$emit("submit", booking);
    },

    toggleEdit(id) {
      this.update = true;
      this.bookingId = id;
      let selectedBooking = this.bookings.find((booking) => booking.id === id);
      this.customer_id = {
        value: selectedBooking.attributes.customer.id,
        text: selectedBooking.attributes.customer.email,
      };
      this.customerSelected = true;
      this.customer.id = selectedBooking.attributes.customer.id;
      this.customer.first_name = selectedBooking.attributes.customer.first_name;
      this.customer.last_name = selectedBooking.attributes.customer.last_name;
      this.customer.email = selectedBooking.attributes.customer.email;
      this.customer.phone_number = selectedBooking.attributes.customer.phone_number;
      let selectedReservation = selectedBooking.attributes.reservations.data[0];
      this.lodging = {
        value: selectedReservation.attributes.lodging.id,
        text: selectedReservation.attributes.lodging.name,
      };
      this.checkin_date = moment(selectedReservation.attributes.checkin)._d;
      this.checkout_date = moment(selectedReservation.attributes.checkout)._d;
      this.reservation.id = selectedReservation.id;
      this.reservation.adults = selectedReservation.attributes.adults;
      this.reservation.children = selectedReservation.attributes.children;
      this.reservation.price = selectedReservation.attributes.price;
      this.reservation.additional_price = selectedReservation.attributes.additional_price;
      this.reservation.discount_value = selectedReservation.attributes.discount_value;
      this.booking.notes = selectedBooking.attributes.notes;
    },

    onSubmit() {
      this.reservation.lodging_id = this.lodging.value;
      this.reservation.discount_id = this.discount.value;
      this.reservation.checkin = moment(this.checkin_date).format("YYYY-MM-DD");
      this.reservation.checkout = moment(this.checkout_date).format("YYYY-MM-DD");
      for (let i = 0; i < this.reserved_add_ons.length; i++) {
        this.reservation.reserved_add_ons_attributes.push({
          title: this.reserved_add_ons[i].text,
          additional_cost_id: this.reserved_add_ons[i].value,
          price: this.reserved_add_ons[i].price,
        });
      }
      this.booking.reservations_attributes.push(this.reservation);
      if (this.customer_id) {
        this.booking.customer_id = this.customer_id.value;
      } else {
        this.booking.customer_attributes = this.customer;
      }
      if (this.update) {
        updateBooking(this.booking, this.bookingId)
          .then((response) => {
            this.$bvModal.hide("booking-modal");
            let index = this.bookings.findIndex((booking) => booking.id === this.bookingId);
            this.bookings.splice(index, 1);
            this.bookings.splice(index, 0, response);
          })
          .catch((error) => this.$refs.form.setErrors(error.response.data.errors));
      } else {
        createBooking(this.booking)
          .then((response) => {
            this.$bvModal.hide("booking-modal");
            this.setBookings(response);
          })
          .catch((error) => {
            this.reservation.reserved_add_ons_attributes = [];
            this.booking.reservations_attributes = [];
            this.calculateRequiredCost();
            this.$refs.form.setErrors(error.response.data.errors);
          });
      }
    },
  },
};
</script>
